var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgManagerIcon = function SvgManagerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.464 15.465A5 5 0 0 1 5 14h8a5 5 0 0 1 5 5v2a1 1 0 1 1-2 0v-2a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v2a1 1 0 1 1-2 0v-2a5 5 0 0 1 1.464-3.536M9 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6M4 7a5 5 0 1 1 10 0A5 5 0 0 1 4 7M19.032 14.88a1 1 0 0 1 1.218-.718A5 5 0 0 1 24 18.999V21a1 1 0 1 1-2 0v-2a3 3 0 0 0-2.25-2.902 1 1 0 0 1-.718-1.218M15.031 2.882a1 1 0 0 1 1.217-.72 5 5 0 0 1 0 9.687 1 1 0 1 1-.496-1.938 3 3 0 0 0 0-5.812 1 1 0 0 1-.72-1.217",
    clipRule: "evenodd"
  })));
};
export default SvgManagerIcon;